var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31364 0.925003C4.50043 0.546592 5.04004 0.546592 5.22683 0.925003L6.30633 3.11196C6.38044 3.26209 6.52361 3.3662 6.68928 3.39042L9.10415 3.74339C9.52164 3.80441 9.68804 4.31759 9.38579 4.61198L7.6392 6.31315C7.5191 6.43014 7.46428 6.59874 7.49262 6.76399L7.90471 9.16669C7.97606 9.58268 7.5394 9.89988 7.16585 9.70343L5.00724 8.56824C4.85887 8.49022 4.6816 8.49022 4.53323 8.56824L2.37462 9.70343C2.00107 9.89988 1.56441 9.58268 1.63576 9.16669L2.04785 6.76399C2.07619 6.59874 2.02137 6.43014 1.90127 6.31315L0.154681 4.61198C-0.147569 4.31759 0.0188251 3.80441 0.436314 3.74339L2.85119 3.39042C3.01686 3.3662 3.16003 3.26209 3.23414 3.11196L4.31364 0.925003Z",
    fill: "#FBD008"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.d388ef0dd5407764ab2f4d3b439d7389.svg";
export { ForwardRef as ReactComponent };